import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";

import { Factory } from "@/data/dao/Factory";
import { PrintDao } from "@/data/dao/service/PrintDao";
import type { Language } from "@/data/model/Enums";

import { logError } from "@/shared/logging/errors";

export const usePrintStore = defineStore("print", () => {
    const customerDao = Factory.getInstance<PrintDao>(PrintDao);

    // state
    const isLoading = ref<boolean>(false);

    // actions
    async function printInterimBill(billId: string, locationId: string, language?: Language): Promise<void> {
        isLoading.value = true;

        try {
            await customerDao.printInterimBill(billId, {
                locationId: locationId,
                language: language,
            });
        } catch (ex) {
            logError(ex);
            const e = ex as { type: string };
            throw e;
        } finally {
            isLoading.value = false;
        }
    }

    return {
        // state
        isLoading,

        // actions
        printInterimBill,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePrintStore, import.meta.hot));
}
